import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEn from "./translation.en";
import translationKo from "./translation.ko";

const resource = {
  en: {
    translation: translationEn,
  },
  ko: {
    translation: translationKo,
  },
};

// 언어 설정 가져오기 (우선순위: URL 파라미터 > localStorage > 브라우저 언어 > 기본값)
const getInitialLanguage = () => {
  if (typeof window !== "undefined") {
    // 1. URL 파라미터 확인
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get("lang");
    if (urlLang === "en" || urlLang === "ko") {
      // URL 파라미터가 있으면 localStorage에도 저장
      localStorage.setItem("i18nextLng", urlLang);
      return urlLang;
    }

    // 2. localStorage 확인
    const savedLang = localStorage.getItem("i18nextLng");
    if (savedLang === "en" || savedLang === "ko") {
      return savedLang;
    }

    // 3. 브라우저 언어 감지: 한국어 설정이 아니면 영문으로 노출
    const browserLang = (
      navigator.languages?.[0] ||
      navigator.language ||
      ""
    ).toLowerCase();
    return browserLang.startsWith("ko") ? "ko" : "en";
  }
  // 4. 기본값
  return "ko";
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: resource,
    lng: getInitialLanguage(),
    fallbackLng: "ko",
    // ns: ['translation'],
    // defaultNS: "translation",
    debug: true,
    keySeparator: ".",
    // keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
